import { TenantLandingResponse } from "@/src/types/tenant";

const TENANT_LANDING_URL = `${process.env.NEXT_PUBLIC_API_URL}/tenant/landing`;
const TENANT_LANDING_LIST_URL = `${process.env.NEXT_PUBLIC_API_URL}/tenant/landing-list`;


export async function getTenantLandingService(
  prefix: string
): Promise<TenantLandingResponse> {
  try {
    const url = new URL(TENANT_LANDING_URL);

    url.searchParams.set("prefix", prefix);

    const response = await fetch(url.toString(), {
      cache: "no-store",
      headers: {
        accept: "application/json",
      },
    });

    if (!response.ok) {
      return {
        success: false,
        message: `Tenant lookup failed with ${response.status}`,
      };
    }

    return response.json();
  } catch (error) {
    console.error("Tenant Service Error:", error);

    return {
      success: false,
      message: "Something went wrong",
    };
  }
}

export interface LandingTenant {
  tenantId: number;
  tenantName: string;
  legalEntityName?: string | null;
  prefix: string;
  additionalInfo?: { logoUrl?: string | null; businessBrief?: string | null } | null;
  businessType?: { businessTypeName?: string | null } | null;
  outlets?: { outletName?: string | null }[];
}

export async function getLandingTenantsService(): Promise<LandingTenant[]> {
  try {
    const response = await fetch(TENANT_LANDING_LIST_URL, {
      cache: "no-store",
      headers: { accept: "application/json" },
    });
    if (!response.ok) return [];
    const data = await response.json();
    return data.tenants ?? [];
  } catch (error) {
    console.error("getLandingTenantsService error:", error);
    return [];
  }
}